import React from 'react'

import { FormProvider } from 'react-hook-form'

import Stack from 'app/components/base/Stack'
import ReviewsGroupField from 'app/features/Store/Reviews/components/ReviewsGroupField'

import ReviewsList from '~/views/Store/ReviewsView/components/ReviewsList'

import { useReviewsView } from './hooks/useReviewsView'

const ReviewsView: RFC = () => {
  const { methods, id, isReceivedSeller, slug } = useReviewsView()

  return (
    <FormProvider {...methods}>
      <Stack
        direction={{ md: 'row', xs: 'column' }}
        spacing={{ md: 3.5, xs: 0 }}
      >
        {isReceivedSeller && (
          <Stack sx={{ minWidth: { md: 230, xs: '100%' }, mt: 2 }}>
            <ReviewsGroupField />
          </Stack>
        )}

        <ReviewsList userId={id} slug={slug} />
      </Stack>
    </FormProvider>
  )
}

export default ReviewsView
